import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

interface ChipProps {
	label: string;
	active?: boolean;
}

export const TabChip: FunctionComponent<ChipProps> = ({ label, active }) => {
	return (
		// Guide §4.5: the tint carries the accent and the label stays dark. A 12px
		// white label on a #FF5A24 fill is 3.12:1 — the accent fill is the CTA's and
		// the active nav item's, not every chip on the screen.
		<div
			className={classNames(
				"ml-2.5 leading-[20px] font-semibold text-xs px-2 py-1 rounded-pill",
				active ? "bg-accent-tint text-text" : "bg-border-soft text-subtle"
			)}
		>
			{label}
		</div>
	);
};
